import React, {useState} from 'react'
import PropTypes from 'prop-types';
import Form from 'components/Form';
import Tr from 'translations/Translations';
import Button from 'components/Button';
import GridBlock from 'components/GridBlock';
import PublishService from 'services/PublishService';
import {isDemandModification, isDemandPreparing} from 'libs/getDemandStatus';
import ModificationService from "services/ModificationService";
import Confirm from "components/popup/confirm/Confirm";
import HeaderService from "services/HeaderService";
import ValidationShema from "constants/ValidationShema";
import ConfirmPublish from "./ConfirmPublish";
import Alert from "components/popup/alert/Alert";
import DemandSectionsService from "services/DemandSectionsService";

function PublishSection(
    {
        id,
        isPublishActive,
        isCancelActive,
        isBackToPreparingActive,
        isBackToModificationActive,
        moveToOfferCollection = () => {
        },
        editable,
        classesRoot,
        setWorking,
        clearPublishResources
    }) {

    const handleSubmit = () => {
        PublishService.save()
    }

    const [openCancelModificationPopup, setOpenCancelModificationPopup] = useState(false);
    const [openPublishPopup, setOpenPublishPopup] = useState(false);
    const [openBackToPreparingPopup, setOpenBackToPreparingPopup] = useState(false);
    const [openBackToModificationPopup, setOpenBackToModificationPopup] = useState(false);
    const [showPublishLimitUsedAlert, setShowPublishLimitUsedAlert] = useState(false);


    const handleConfirmCancelModification = () => {
        setOpenCancelModificationPopup(false);
        setWorking(true);
        ModificationService.cancel(id).then((resp) => {
            if (resp) {
                moveToOfferCollection();
            }
        });
    };

    const handleConfirmPublish = () => {

        if (isDemandPreparing()) {
            setOpenPublishPopup(false);
            setWorking(true);
            PublishService.publish(id).then((resp) => {
                if (resp != null) {
                    if (resp) {
                        HeaderService.get(id);
                        PublishService.markFirstPublication(id);
                        moveToOfferCollection();
                    } else {
                        setWorking(false);
                        setShowPublishLimitUsedAlert(true);
                    }
                } else {
                    setWorking(false);
                    clearPublishResources();
                }
            });
        } else if (isDemandModification()) {
            setOpenPublishPopup(false);
            setWorking(true);

            ModificationService.publish(id).then((resp) => {
                if (resp) {
                    HeaderService.get(id);
                    moveToOfferCollection();
                } else {
                    setWorking(false);
                    clearPublishResources();
                }
            });
        }
    };

    const handleConfirmBackToPreparing = () => {
        setOpenBackToPreparingPopup(false);
        setWorking(true);
        PublishService.backToPreparing(id).then(() => {
            setWorking(false);
            DemandSectionsService.getPreparingSections(id).then(() => {});
        });
    }

    const handleConfirmBackToModification = () => {
        setOpenBackToModificationPopup(false);
        setWorking(true);
        ModificationService.backToModification(id).then(() => {
            setWorking(false);
            DemandSectionsService.getPreparingSections(id).then(() => {});
        });
    }

    return (
        <div>
        <Form
            onSubmit={handleSubmit}
            id={'mp_1_publication'}
            validationSchema={ValidationShema.any()}
        >
            {(formikProps) => (
                <>
                    <GridBlock
                        direction='column'
                        alignItems='center'
                        className={classesRoot}
                    >

                        {!!isBackToPreparingActive && <Button
                            disabled={!editable}
                            onClick={() => setOpenBackToPreparingPopup(true)}
                        >
                            {Tr('back_to_edit')}
                        </Button>}
                        {!!isBackToModificationActive && <Button
                            disabled={!editable}
                            onClick={() => setOpenBackToModificationPopup(true)}
                        >
                            {Tr('back_to_modification')}
                        </Button>}
                        <Button
                            disabled={!editable || !isPublishActive}
                            onClick={() => setOpenPublishPopup(true)}
                        >
                            {Tr('publish')}
                        </Button>

                        {isDemandModification() && <Button
                            disabled={!editable || !isCancelActive}
                            onClick={() => setOpenCancelModificationPopup(true)}
                        >
                            {Tr('modification_cancel')}
                        </Button>
                        }
                    </GridBlock>
                    <Confirm
                        open={openCancelModificationPopup}
                        onConfirm={handleConfirmCancelModification}
                        onCancel={() => setOpenCancelModificationPopup(false)}
                        confirmText="modification_cancel_popup_text"
                    />
                    <ConfirmPublish
                        open={openPublishPopup}
                        onConfirm={handleConfirmPublish}
                        onCancel={() => setOpenPublishPopup(false)}
                    />
                    <Confirm
                        open={openBackToPreparingPopup}
                        onConfirm={handleConfirmBackToPreparing}
                        onCancel={() => setOpenBackToPreparingPopup(false)}
                        confirmText="back_to_edit_confirm"
                    />
                    <Confirm
                        open={openBackToModificationPopup}
                        onConfirm={handleConfirmBackToModification}
                        onCancel={() => setOpenBackToModificationPopup(false)}
                        confirmText="back_to_modification_confirm"
                    />
                </>
            )}
        </Form>
            {showPublishLimitUsedAlert && <Alert
                confirmText={Tr('publish.limit.used')}
                open={true}
                onClose={() => setShowPublishLimitUsedAlert(false)}
                maxWidth='sm'
            />}
        </div>
    )
}

PublishSection.propTypes = {
    classes: PropTypes.any,
}

export default PublishSection;